export default __webpack_public_path__ + "static/media/ourVisionImage.d555a4f5.png";